import { Suspense } from 'react';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { Welcome } from '@modules/Dashboard/views/Welcome';


export const WelcomePage = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <Welcome/>
      </Suspense>
    </ErrorBoundary>
  );
};
